/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

const version = '__buildVersion__';

export { version };

export { BroadpeakSessionInitializationData } from './model/BroadpeakSessionInitializationData';
export { BroadpeakAdsSessionData } from './BroadpeakAdsSession';

export { createBroadpeakPlayer, createBroadpeakSession } from './BroadpeakFactory';
export { BroadpeakAdsPlayer, AdViewState } from './BroadpeakAdsPlayer';
export { BroadpeakLoggerLevel } from './model/BroadpeakSessionInitializationData';
